import { render, staticRenderFns } from "./AcknowledgedFaultsTable.vue?vue&type=template&id=34f6d343"
import script from "./AcknowledgedFaultsTable.vue?vue&type=script&lang=js"
export * from "./AcknowledgedFaultsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports